export default "__VITE_ASSET__eaac9d40__"